import { render } from "./FooterBar.vue?vue&type=template&id=48876bda&bindings={\"icons\":\"setup\"}"
import script from "./FooterBar.vue?vue&type=script&lang=js"
export * from "./FooterBar.vue?vue&type=script&lang=js"
script.render = render

export default script